import apiFetch from '../apiFetch'

export default function (token, dossierSubTypeId) {
  return apiFetch({ endPoint: `ivaType/ByDossierSubType?dossierSubTypeId=${dossierSubTypeId}`, method: 'GET', body: null, token: token })
}
